import { createFileRoute, useParams } from '@tanstack/react-router';

import { CertificateView } from '@/views/awards/certificate-view.tsx';

// ADR-022 阶段 C：证书打印页。`awards_` 末尾的 `_` 使其
// 脱离 /awards wall 布局，独立渲染为自己的页面（仅证书 + 打印
// 按钮），对应 Next 的 /awards/[id]/certificate 路由。
export const Route = createFileRoute('/_learner/awards_/$id/certificate')({
  component: CertificatePage,
});

function CertificatePage() {
  const { id } = useParams({ from: '/_learner/awards_/$id/certificate' });
  return <CertificateView issuanceId={id} />;
}
